import DetailedExplanationList from "~/components/molecules/DetailedExplanationList"
import { CuratedNewGradJobDetail } from "~/entities/CuratedNewGradJob"
import { NewGradJobDetail } from "~/entities/NewGradJob"

import * as styled from "./styled"

interface Props {
  job: NewGradJobDetail | CuratedNewGradJobDetail
}

const Requirements = ({ job }: Props) => {
  return (
    <styled.EachTabContainer>
      <div className="content-wrapper">
        <DetailedExplanationList
          direction="Horizontal"
          heading="募集要項"
          items={[
            {
              heading: "応募資格",
              description: job.qualification,
            },
            {
              heading: "給料",
              description: job.salary,
            },
            {
              heading: "福利厚生",
              description: job.employee_benefits,
            },
            {
              heading: "勤務時間",
              description: job.work_pattern,
            },
            {
              heading: "勤務地",
              description: job.location,
            },
            {
              heading: "募集期間",
              description: job.entry_period,
            },
            {
              heading: "入社時期",
              description: job.enter_period,
            },
            {
              heading: "選考フロー",
              description: job.selection_flow,
            },
          ]}
        />
      </div>
    </styled.EachTabContainer>
  )
}

export default Requirements
